import React, {Fragment} from 'react';

class SelectRender extends React.Component {
	static defaultProps = {
		disabled: false,
		readOnly: false,
		className: '',
		addClassName: '',
		maxLength: 255,
		options: [],
	};

	render() {
		const {id, input, placeholder, className, type, disabled,
			readOnly, maxLength, autoComplete, meta, options} = this.props;
		return (
			<Fragment>
				<select
					{...input}
					id={id}
					placeholder={placeholder}
					autoComplete={autoComplete}
					className={className}
					type={type}
					disabled={disabled}
					readOnly={readOnly}
					maxLength={maxLength === 0 ? 100000 : maxLength}
				>
					{options.map((option, i) => (
						<option key={i} value={option.value}>{option.label}</option>
					))}
				</select>
				{meta.error && meta.touched &&
					<div className='error text-danger'>{meta.error}</div>}
			</Fragment>
		);
	}
}

export default SelectRender;



// WEBPACK FOOTER //
// ./src/common/fields/renders/SelectRender.js